module.exports = __webpack_public_path__ + "static/media/blank-check.977a7c69.png";